import React, { forwardRef } from "react"
import type { LucideProps } from "lucide-react"

export const MessageBubbleIcon = forwardRef<SVGSVGElement, LucideProps>(
  (
    { size = 24, color = "currentColor", strokeWidth = 2, className, ...props },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <path
          key="bubble-path"
          d="M14.4343 20.7285C12.1157 21.2801 9.6762 20.9855 7.5556 19.8976L1 22L3.2222 15.5643C2.1344 13.4436 1.8397 11.0042 2.3914 8.6855C2.9430 6.3669 4.3046 4.3215 6.2309 2.9179C8.1572 1.5143 10.5214 0.8449 12.8976 1.0303C15.2737 1.2157 17.5056 2.2436 19.1909 3.9289C20.8763 5.6143 21.9041 7.8461 22.0896 10.2222C22.2749 12.5984 21.6055 14.9627 20.2020 16.8889C18.7984 18.8152 16.7529 20.1768 14.4343 20.7285Z"
        />
      </svg>
    )
  },
)

MessageBubbleIcon.displayName = "MessageBubbleIcon"

export const MessageBubblePlusIcon: React.FC<LucideProps> = ({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path
        key="bubble-outline"
        d="M14.4343 20.7285C12.1157 21.2801 9.6762 20.9855 7.5556 19.8976L1 22L3.2222 15.5643C2.1344 13.4436 1.8397 11.0042 2.3914 8.6855C2.9430 6.3669 4.3046 4.3215 6.2309 2.9179C8.1572 1.5143 10.5214 0.8449 12.8976 1.0303C15.2737 1.2157 17.5056 2.2436 19.1909 3.9289C20.8763 5.6143 21.9041 7.8461 22.0896 10.2222C22.2749 12.5984 21.6055 14.9627 20.2020 16.8889C18.7984 18.8152 16.7529 20.1768 14.4343 20.7285Z"
      />
      <path
        key="plus-symbol"
        d="M12 8V14M9 11H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const MessageBubbleIconActive = forwardRef<SVGSVGElement, LucideProps>(
  (
    { size = 24, color = "currentColor", strokeWidth = 2, className, ...props },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <path
          key="bubble-active-path"
          d="M14.0912 20.748C12.0044 21.2444 9.8090 20.9792 7.9004 20.0003L2 22L4.0004 16.1003C3.0213 14.1917 2.7562 11.9962 3.2526 9.9094C3.7491 7.8225 4.9746 5.9817 6.7082 4.7185C8.4419 3.4553 10.7697 2.8528 13.1082 3.0197C15.4468 3.1865 17.6554 4.1117 18.9722 5.6284C20.2889 7.1452 21.0141 9.1539 21.1809 11.2924C21.3478 13.431 20.7453 15.5587 19.4822 17.2925C18.2190 19.0261 16.4780 20.2516 14.0912 20.748Z"
          fill="currentColor"
          stroke="currentColor"
        />
      </svg>
    )
  },
)

MessageBubbleIconActive.displayName = "MessageBubbleIconActive"
